import * as types from "../actions/actionTypes";

// state = [] : Start out with no accounts
export default function invitation(state = [], action) {
  switch (action.type) {
    case types.GET_INVITATION:
      return action.invitation;
    default:
      return state;
  }
}
